module.exports = __webpack_public_path__ + "static/media/isotipo-loading.cf345ecb.png";